import React, { Component } from 'react'
import AdminPost from '../multi/AdminPost'

import { db } from '../../../firebase.js'

import { EditorState, convertToRaw, ContentState } from 'draft-js'
import { Editor } from 'react-draft-wysiwyg'
import draftToHtml from 'draftjs-to-html'
import '../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css'

import { stripStylesFromHtmlString } from '../../../helpers'

class AdminBlog extends Component {
  constructor() {
    super()
    this.state = {
      currentView: "blog",
      editorState: EditorState.createEmpty(),
      headline: "",
      bodytext: "",
      posts: []
    }
  }

  componentDidMount() {
    const dbPosts = db.ref('posts')
    dbPosts.on('value', (snapshot) => {
      let posts = snapshot.val()
      let newState = []
      for (let post in posts) {
        newState.push({
          id: post,
          headline: posts[post].headline,
          bodytext: posts[post].bodytext,
          timestamp: posts[post].timestamp
        })
      }
      this.setState({
        posts: newState.sort((a, b) => {return b.timestamp - a.timestamp})
      })
    })
  }

  componentWillUnmount() {
    const dbPosts = db.ref('posts')
    dbPosts.off()
  }

  handlePostSubmit = (e) => {
    e.preventDefault()
    let bodyText = draftToHtml(convertToRaw(this.state.editorState.getCurrentContent()))
    let bodyTextWithRemovedStyles = stripStylesFromHtmlString(bodyText)
    const dbPosts = db.ref('posts')
    const post = {
      headline: this.state.headline,
      bodytext: bodyTextWithRemovedStyles,
      timestamp: Date.now()
    }
    dbPosts.push(post)
    this.setState({
      headline: "",
      bodytext: ""
    })
    //reset the bodytext input after submit
    const editorState = EditorState.push(this.state.editorState, ContentState.createFromText(''))
    this.setState({ editorState })
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  deletePost = (post) => {
    const postRef = db.ref(`/posts/${post.id}`);
    postRef.remove();
  }

  onEditorStateChange = (editorState) => {
    this.setState({
      editorState
    })
  }

  render() {
    const { editorState } = this.state

    return (
      <div className="flex flex-column">
				<section className="mb5 f4">
					<div className="pathway f2 mb2 white bg-dark-gray pa3 card">
						ADD POST TO BLOG
					</div>
          <article className="bg-white card pa2 flex flex-column">
            <div className="form-group flex flex-column mb2">
              <input 
                placeholder="Headline"
                name="headline" 
                className="form-control headline-input pa2 open-sans-cond f3 b--moon-gray b--solid bw025" 
                value={this.state.headline} 
                onChange={this.handleChange}/>
            </div>
            <div className="form-group flex flex-column mb2">
              <Editor
                placeholder="Body text"
                editorClassName="form-control body-input open-sans-cond f3 h4 lh-copy ph2 b--moon-gray b--solid bw025"
                toolbarClassName="b--moon-gray"
                editorState={editorState}
                onEditorStateChange={this.onEditorStateChange}
                toolbar={{
                  options: ['inline', 'link'],
                  inline: {
                    options: ['bold', 'italic', 'underline']
                  },
                  link: {
                    options: ['link', 'unlink']
                  }
                }}
                stripPastedStyles={true}
              />
            </div>
            <div onClick={(e) => {this.handlePostSubmit(e)}} className="dib link pathway pointer self-end bg-animate dim bg-gray ph3 pv2 f3 f2-ns tc near-white">POST TO BLOG</div>
          </article>
        </section>
				<section className="w-100 bg-moon-gray flex flex-column">
					<div className="pathway f2 mb2 white bg-dark-gray pa3 card">
						BLOG POSTS
					</div>
          {this.state.posts.map( (post) => {
            return (
              <AdminPost post={post} key={post.id} deletePost={this.deletePost} />
            )
          })}
        </section>
      </div>
    )
  }
}

export default AdminBlog


// WEBPACK FOOTER //
// ./src/components/admin/pages/AdminBlog.js